import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import { createRoot } from "react-dom/client";
import "./global.css";
import { SERVICE_URL } from "./shared/config.ts";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [SERVICE_URL],
  enabled: SERVICE_URL === "https://marusf.org"
});

const rootElement = document.getElementById("root")!;

createRoot(rootElement).render(<App />);
